import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { gameState, inventoryState } from "../../state/stateManager";
import { createGainedItem, sendAlert } from "../../utils";
import { Resources } from "../../Resources";

export default class HoneyEquipmentMenu extends Scene {
  constructor() {
    super();
    this.activeItem = 0;
    this.menuItems = 2;
  }
  onActivate() {
    this.honey = document.getElementById("honey-equipment");
    this.honey.classList.add("activeMenu");
    this.menu = document.getElementById("honey-menu");
    this.menu.classList.add("activeMenuMenu");
    this.medium = document.getElementById("medium-extractor");
    this.large = document.getElementById("large-extractor");
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      goToScene("onlineMarket");
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      Resources.Click.play();
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log("pressed space");
      let inventory = inventoryState.getInventory();
      let coins = gameState.getCoins();
      if (this.activeItem === 0) {
        //buy medium
        if (inventory.honeyExtractors.includes("mediumExtractor")) {
          Resources.Error.play();
          sendAlert("You Already Own This Item");
        } else {
          //buy it
          if (coins >= 500) {
            //buy it
            inventory.honeyExtractors.push("mediumExtractor");
            coins = coins - 500;
            createGainedItem("Medium Extractor");
            Resources.Coins.play();
            gameState.setCoins(coins);
            inventoryState.setInventory(inventory);
          } else {
            Resources.Error.play();
            sendAlert("Not Enough Coins");
          }
        }
      } else if (this.activeItem === 1) {
        //buy large
        if (inventory.honeyExtractors.includes("largeExtractor")) {
          Resources.Error.play();
          sendAlert("You Already Own This Item");
        } else {
          //buy it
          if (coins >= 1000) {
            //buy it
            inventory.honeyExtractors.push("largeExtractor");
            coins = coins - 1000;
            createGainedItem("Medium Extractor");
            gameState.setCoins(coins);
            inventoryState.setInventory(inventory);
          } else {
            Resources.Error.play();
            sendAlert("Not Enough Coins");
          }
        }
      }
    }
    this.showCorrect();
  }
  showCorrect() {
    switch (this.activeItem) {
      case 0:
        this.medium.classList.add("activeProduct");
        this.large.classList.remove("activeProduct");
        break;
      case 1:
        this.medium.classList.remove("activeProduct");
        this.large.classList.add("activeProduct");
        break;
      default:
        this.medium.classList.add("activeProduct");
        this.large.classList.remove("activeProduct");
        break;
    }
  }
  onDeactivate() {
    this.honey.classList.remove("activeMenu");
    this.menu.classList.remove("activeMenuMenu");
  }
}
